import { render } from "./LoadingSpinnerMessages.vue?vue&type=template&id=1ecbef14&scoped=true"
const script = {}

import "./LoadingSpinnerMessages.vue?vue&type=style&index=0&id=1ecbef14&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecbef14"]])

export default __exports__